export function transformToHTML5(html: string) {
  return html
    .replace(/<(\/?)b\b((?:[^>"']|"[^"]*"|'[^']*')*)>/gm, '<$1strong$2>')
    .replace(/<(\/?)i\b((?:[^>"']|"[^"]*"|'[^']*')*)>/gm, '<$1em$2>');
}
